import Constants from 'expo-constants';

import {ENV_CONFIG, DEFAULT_CONFIG} from './constants';
import {featBitOptions} from './featbit';

let configOverride = ENV_CONFIG ?? {ssoConfigs: {}};

const configOverrideEnv = Constants.expoConfig?.extra?.configOverride;

if (configOverrideEnv) {
  try {
    let parsedValue = configOverrideEnv;

    if (typeof configOverrideEnv === 'string') {
      const trimmed = configOverrideEnv.trim();
      if (trimmed.length > 0) {
        parsedValue = JSON.parse(trimmed);
      }
    }

    if (
      parsedValue &&
      typeof parsedValue === 'object' &&
      !Array.isArray(parsedValue) &&
      Object.keys(parsedValue).length > 0
    ) {
      configOverride = parsedValue;
    }
  } catch (e) {}
}

const ssoConfigsOverride = configOverride.ssoConfigs ?? {};

export const config = {
  ...DEFAULT_CONFIG,
  ...configOverride,
  ssoConfigs: {
    ...DEFAULT_CONFIG.ssoConfigs,
    ...ssoConfigsOverride,
  },
};

export {featBitOptions};

export * from './constants';
